import type { LeadType } from "../types";

/**
 * Shared i18n key for a lead type value (Almikia Epic E2). Both the lead
 * form's select (DealInputs) and the show page (DealShow) resolve a
 * `lead_type` value through this key, so they never drift.
 */
export const leadTypeTranslationKey = (leadType: LeadType) =>
  `resources.deals.lead_types.${leadType}` as const;

/**
 * Almikia batch EQ3 (TASK-111): same Spanish message as the SQL guard
 * `enforce_deals_lead_type_guard()`, so the demo and the real backend refuse alike.
 */
export const LEAD_TYPE_CHANGE_MESSAGE =
  "Solo Dirección o un Lead Manager puede cambiar el tipo de lead";

/**
 * Only direccion and lead_manager may change an existing lead's type (SQL guard on
 * UPDATE OF lead_type). Tolerates a role-less identity (refused). UI hiding is cosmetic only.
 */
export const canChangeLeadType = (role: string | null | undefined): boolean =>
  role === "direccion" || role === "lead_manager";
